import constants from './constants';

const getCustomerCode = (state) => state[constants.NAME].customerCode;

const getIsGlobalConfEditCustomer = (state) => !!state[constants.NAME].isGlobalConfEditCustomer;

export default {
  getCustomerCode,
  getIsGlobalConfEditCustomer,
};
